<template>
 <!-- Component for individual word editing -->
  <div>
    <!-- Component header -->
    <div class="d-flex">

       <!-- Section title -->
      <div class="my-3">{{ title }}</div>

      <!-- Word input and button -->
      <div class="ml-1 my-3">
        <input
          v-if="showInput"
          v-model="word"
          type="text"
          class="mr-3">

        <!-- Button to add or confirm word -->
        <span
          class="btn btn-secondary btn-sm small py-0"
          :disabled="buttonDisabled"
          @click="addOrConfirm">
          {{ labelButton }}
        </span>

         <!-- Error message if button is disabled -->
        <span v-if="buttonDisabled" class="mx-2 text-danger">
            {{ $t('lang.label.exists') }}
        </span>
      </div>
    </div>

     <!-- List of words -->
    <div class="mx-1 p-2 border border-secondary">
      <span  v-for="(item, i) in items" :key="i">
        <template v-if="!item.markForDeletion">
          <span class="mr-1" :class="!item.id ? 'font-weight-bold' : ''" >{{ item.word }}</span>
          <sup><i @click="markForDeletion(i)" class=" cursor-pointer icon-close text-danger mr-3"></i></sup>
        </template>
      </span>
    </div>

    <!-- Save button -->
    <div class="ml-1 text-left mt-4">
      <span @click="save" class="btn btn-primary btn-sm">
        {{ $t('lang.button.save_blacklist')}}
      </span>
    </div>

  </div>
</template>

<script>
export default {
  name: 'IndividualWordEditor',
  props: {
    words: {
      type: Array,
      required: true,
      default: () => [],
    },
    title: {
      type: String,
      required: false,
      default: ''
    }
  },
  computed: {
     // Dynamic button label
    labelButton (){
      return ( this.insertingWord ) ? this.$t('lang.label.donefilter') : this.$t('lang.button.new_word')
    }
  },
  watch: {
    word(newValue){
        const findWordInList = this.words.find( el =>  ( el.word.toLowerCase() == newValue.toLowerCase() ) && !el.markForDeletion);
        if(!findWordInList){
          this.buttonDisabled = false
        } else {
          this.buttonDisabled = true;
        }
    }
  },
  data() {
    return {
      exists: false,
      word: null,
      showInput: false,
      insertingWord: false,
      buttonDisabled: false,
      items: [],
    };
  },

  mounted() {
    // Initialize the list of words
    this.items = this.words;
  },

  methods: {

    // Save method
    save(){
      this.$emit('save');
    },

    // Mark word for deletion
    markForDeletion(index){
      this.items[index].markForDeletion = true
    },

    // Add or confirm word
    addOrConfirm(){
      // When confirming a word entered in the input to be added to the list.
      if( this.insertingWord ) {

        // Find the word in the list
        const findWordInList = this.items
                                .find( el =>
                                  el.word.toLowerCase() == this.word.toLowerCase()
                                );

        if(!findWordInList){

           // Add a new word to the list
          const newitem = {
            id: null,
            word:  this.word,
            markForDeletion: false,
          }
          this.items.push(newitem)
          this.showInput = false;
          this.insertingWord = false
          this.word = ''
        } else {

          // Find and restore word if marked for deletion
          const findWordInList = this.items
                                  .findIndex( el =>
                                    (el.word.toLowerCase() == this.word.toLowerCase())
                                    && el.markForDeletion
                                  );
          if(findWordInList){
            this.items[findWordInList].markForDeletion = false
            this.showInput = false;
            this.insertingWord = false
            this.word = ''
          } else {
            this.exists = true;
          }
        }

      } else { // When pressing the "Add" button to initiate word insertion in the input.
        this.showInput = true;
        this.insertingWord = true
      }
    },

  },
};
</script>
